import styled from '@emotion/styled';
import { Box } from '~Styles';

const StyledWrapper = styled(Box)`
  font-family: var(--eposFontFamily);
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  background-color: var(--eposSurface);
  color: var(--eposText);

  @media (orientation: portrait) {
    flex-direction: column;
  }
`;

/**
 * Root wrapper for the Express Kiosk. The palette lives in styles/index.css as
 * CSS custom properties, so this is purely layout: landscape or portrait via an
 * orientation media query, so screens inside don't need to know which one.
 */
export const Wrapper = StyledWrapper;

/** A panel inside Wrapper, e.g. the menu vs. the cart/summary side. */
export const Panel = styled(Box)<{ grow?: number }>`
  flex: ${({ grow }) => grow ?? 1} 1 0;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

/** Price text, styled with the venue's theme price color. */
export const PriceText = styled.span`
  font-family: var(--eposFontFamily);
  font-weight: 700;
  color: var(--eposPrice);
`;
